import { compose } from 'redux';
import { connect } from 'react-redux';
import { selectNavIsOpen } from 'selectors/ui';
import { hideNavVisibility } from 'reducers/ui';
import { hot } from 'react-hot-loader';

import AppLayout from './AppLayout';

const mapStateToProps = state => ({
  navIsOpen: selectNavIsOpen(state),
});

const mapDispatchToProps = {
  hideNavVisibility,
};

export default compose(hot(module), connect(mapStateToProps, mapDispatchToProps))(AppLayout);
